import { render } from "./CmpPanelFacturas.vue?vue&type=template&id=518a01c2"
import script from "./CmpPanelFacturas.vue?vue&type=script&lang=js"
export * from "./CmpPanelFacturas.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__